<template>
  <div>
    <BNav align="center" class="featured-experience">
      <BNavText
        active
        class="featured-content featured-merch"
        :class="{ 'featured-merch-local': localExperience === getMerch }"
        @click="changeLocalExp(getMerch)"
      >
        {{ $t('home.pre-home.featuredExperience.merch') }}
      </BNavText>

      <BNavText
        class="featured-content featured-design"
        :class="{ 'featured-design-local': localExperience === getDesign }"
        @click="changeLocalExp(getDesign)"
      >
        {{ $t('home.pre-home.featuredExperience.design') }}
      </BNavText>
    </BNav>

    <Sector v-if="listExist('prehome_featured', localExperience)">
      <Grid :items="list('prehome_featured', localExperience)">
        <template #default="slotProps">
          <NormalVectorOverlay :data="slotProps.data" />
        </template>
      </Grid>
    </Sector>

    <Button
      class="d-flex justify-content-center more-button"
      shape="full"
      :color="localExperience + '-color'"
      :to="$trailingSlash(localePath(seeAllLink))"
    >
      {{ $t(`home.pre-home.featuredExperience.${localExperience}Button`) }}
    </Button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { BNav, BNavText } from 'bootstrap-vue';

import Button from 'UI/Button';
import Grid from '@/components/Common/Grid';
import NormalVectorOverlay from '@/components/Vectors/NormalVectorOverlay';
import Sector from '@/components/Home/Sector';

export default {
  components: {
    BNav,
    BNavText,
    Button,
    Grid,
    NormalVectorOverlay,
    Sector
  },
  data() {
    return {
      localExperience: 'merch'
    };
  },
  async fetch() {
    const merch_prehome_featured = this.$store.dispatch('listings/GET_LIST', {
      name: 'prehome_featured',
      type: 'preview',
      exp: this.getMerch
    });
    const design_prehome_featured = this.$store.dispatch('listings/GET_LIST', {
      name: 'prehome_featured',
      type: 'preview',
      exp: this.getDesign
    });
    return Promise.all([merch_prehome_featured, design_prehome_featured]);
  },
  computed: {
    ...mapGetters('experience', ['getDesign', 'getMerch']),
    ...mapGetters('listings', ['list', 'listExist']),
    seeAllLink() {
      return this.localExperience === this.getDesign
        ? 'design-featured-graphics'
        : 'merch-featured-designs';
    }
  },
  methods: {
    changeLocalExp(exp) {
      this.localExperience = exp;
    }
  }
};
</script>

<style lang="scss" scoped>
.featured-content {
  cursor: pointer;
  font-size: 16px;
  padding: 5px 10px;
  margin: 0px 10px;
}
.featured-design {
  color: $defaultColor;
}
.featured-design-local {
  border-bottom: $defaultColor solid 2.5px;
}
.featured-experience {
  border-bottom: 0.5px solid rgba(#b7b7b7, 0.5);
  margin-bottom: 10px;
}
.vx-custom-background .featured-experience {
  border-bottom: 0.5px solid rgba(#3a3a3a, 0.5) !important;
}
.featured-merch {
  color: $defaultColor;
}
.featured-merch-local {
  border-bottom: $defaultColor solid 2.5px;
}
.more-button {
  margin: 20px 0px;
}
</style>
